import type { FaireProductEntity } from "../../entity_types/product";

export const p_fk7jtvbczw: FaireProductEntity = {
  token: "p_fk7jtvbczw",
  type: "product",
  name: "Moroccan Nesting Dish Set - Blue Stripe",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/7a721fd18a6e1e653b49520f2dc0fd6f2217f09539c16ef25b03ffbb2d7d2de5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc0ae1e8cb6618957bc7e38f57ff751c971728c8053319824a6595994588e81e.jpeg",
    "https://cdn.faire.com/fastly/6af4b662f191748fb16c447a0ecdc083eae8533204dbf30f6e94a74d8ed2b762.jpeg",
    "https://cdn.faire.com/fastly/a1807e889fd09e95b99964f0a54907bed88daca66095dd2723578c8be3edb7c5.jpeg",
    "https://cdn.faire.com/fastly/98f3c98160c6f7be3cab2564c3844245db49389b4ad765a14c3c2762f0273e9e.jpeg",
    "https://cdn.faire.com/fastly/440ab299599b14bcbbb1b0c371f074107d64a6f4c0620fa846ee6ce14e0612d9.jpeg",
  ],
  priceDollars: 45,
  description:
    "Bring the beauty of Moroccan craftsmanship to your table with this stunning set of three handmade nested dishes. Each piece is skillfully crafted by artisans in Morocco, showcasing a timeless blend of tradition and functionality.\n\nThree different sized dishes nest together seamlessly, perfect for serving, organizing, or displaying. Each dish is made by hand, making every set one-of-a-kind. The interior features a smooth white glaze adorned with delicate blue stripes, adding a touch of sophistication to your table. Ideal for serving snacks, side dishes, or desserts, as well as for stylish storage or decorative display.\n\nThoughtfully designed and ethically made, they also make the perfect gift for someone who appreciates global artistry.\n\nDimensions (may vary slightly due to handmade nature:\n-Small: 1.6'' x 5.75'' diameter\n-Medium: 1.8'' x 7.5'' diameter\n-Large: 2.4'' x 9.6'' diameter",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:16.003Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
